.heading {
  font-size: 28px;
  line-height: 1.3;
  margin-bottom: 16px;
}

.preview {
  margin-bottom: 16px;
}

.actions {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

$bottomsheet-breakpoint: 630px;

.shareButtonWrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  width: 100%;

  & > button {
    flex: 1;
    min-width: 220px;
    white-space: normal;

    @media (width > $bottomsheet-breakpoint) {
      max-width: 50%;
    }
  }
}

.closeButtonDesktop {
  position: absolute;
  top: 4px;
  inset-inline-end: 4px;
  padding: 8px;

  @media (width <= $bottomsheet-breakpoint) {
    display: none;
  }
}

.closeButtonMobile {
  margin-top: 16px;
  margin-bottom: -18px;

  @media (width > $bottomsheet-breakpoint) {
    display: none;
  }
}
